<template>
  <div class="px-8">
    <div>
      <form @submit.prevent="">
        <VFormInput
          placeholder="Enter title"
          label="Title*"
          :reset="resetField"
          :initialValue="initialValues.title"
          :error="errors.title"
          @update="value => $emit('set', 'title', value)"
        />
        <div class="flex items-center mb-6">
          <div class="h-12 mb-2 -mt-6">
            <VFormUpload
              label="File*"
              :reset="resetField"
              :accept="['application/pdf', 'image/png']"
              :initialValue="initialValues.file"
              @upload="value => $emit('set', 'file', value[0])"
            />
          </div>
          <div class="px-12">or</div>
          <div class="w-4/6">
            <VFormInput
              placeholder="Enter Link"
              label="Link*"
              :error="errors.link"
              :reset="resetField"
              :initialValue="initialValues.link"
              @update="value => $emit('set', 'link', value)"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import VFormInput from '@/components/base/VFormInput';
import VFormUpload from '@/components/base/VFormUpload';

export default {
  name: 'ResourcesForm',
  components: {
    VFormInput,
    VFormUpload,
  },
  props: {
    errors: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    resetField: {
      type: Boolean,
      required: false,
      default: true,
    },
    initialValues: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
};
</script>
